import React, { Component } from 'react'
import '../css/components/PeriodToggle.scss'
import { connect } from 'react-redux'
import { changePeriod, receiveMagnetometer } from '../actions'
import RadioButton from '../components/widgets/RadioButton'
import { Option } from '../constants/urls'

const PERIODS: Option[] = [2, 6, 24]

interface PeriodToggleProps {
  dispatch: (arg: any) => void // ToDo: Type
  magnetometers: any // ToDo: Type
  period: Option
}

class PeriodToggle extends Component<PeriodToggleProps> {
  toggle = (e: any) => {
    // ToDo: Type
    const { dispatch, magnetometers } = this.props
    dispatch(changePeriod(parseInt(e.target.value, 10) as Option))
    dispatch(receiveMagnetometer(magnetometers, parseInt(e.target.value, 10) as Option)) // ToDo: There is probably better way to do this
  }

  getPeriods() {
    return PERIODS.map((per: Option, index: number) => {
      return (
        <RadioButton
          key={index}
          name="period-toggle"
          value={per}
          unit="h"
          action={this.toggle}
          checked={per === this.props.period}
        />
      )
    })
  }

  render() {
    return <div className="period-toggle">{this.getPeriods()}</div>
  }
}

interface PeriodToggleState {
  period: Option
  magnetometers: any // ToDo: Type
}

function mapStateToProps(state: PeriodToggleState) {
  const { period, magnetometers } = state
  return {
    period,
    magnetometers: magnetometers.data,
  }
}

export default connect(mapStateToProps)(PeriodToggle)
